import React from 'react';
import { logWebHeaderUpgradeToProTapped } from '@alltrails/analytics/amplitudeFunctions';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import useUser from 'hooks/useUser';
import { FormattedMessage } from 'react-intl';
import useFeatures from 'hooks/useFeatures';
import * as styles from './styles/styles.module.scss';

const MobileHomeLink = () => {
  const features = useFeatures();
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();

  if (!user) {
    return (
      <a className={styles.link} href={LanguageSupportUtil.wrapUrlSafe('/signup?ref=homepage_signup_mobileheader', languageRegionCode)}>
        <FormattedMessage defaultMessage="Sign up" />
      </a>
    );
  }

  return (
    <a
      className={styles.link}
      href={LanguageSupportUtil.wrapUrlSafe('/pro?ref=homepage_pro_mobileheader', languageRegionCode)}
      onClick={() => logWebHeaderUpgradeToProTapped()}
    >
      {user.isPromoEligible && features.includes('seven_day_trial') ? (
        <FormattedMessage defaultMessage="Try Pro" />
      ) : (
        <FormattedMessage defaultMessage="Get Pro" />
      )}
    </a>
  );
};

export default MobileHomeLink;
